import { z } from "zod";
import { CrmLifecycleStageSchema } from "./crm-activity.js";
// ─── Base Fields ───────────────────────────────────────────
export const CompanySchema = z.object({
    id: z.string().uuid(),
    name: z.string().min(1).max(200),
    domains: z.array(z.string().max(253)),
    sector: z.string().max(100).nullable(),
    tags: z.array(z.string().min(1).max(50)),
    contactCount: z.number().int().default(0),
    ownerEmail: z.string().email().nullable().default(null),
    source: z.string().max(80).nullable().default(null),
    lifecycleStage: CrmLifecycleStageSchema.default("account"),
    lastActivityAt: z.string().datetime().nullable().default(null),
    archivedAt: z.string().datetime().nullable().default(null),
    archivedBy: z.string().email().nullable().default(null),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
// ─── Create / Update ───────────────────────────────────────
export const CompanyCreateSchema = z.object({
    name: z.string().min(1).max(200),
    domains: z.array(z.string().max(253)).default([]),
    sector: z.string().max(100).optional(),
    tags: z.array(z.string().min(1).max(50)).default([]),
    ownerEmail: z.string().email().nullable().optional(),
    source: z.string().max(80).nullable().optional(),
    lifecycleStage: CrmLifecycleStageSchema.optional(),
});
export const CompanyUpdateSchema = z.object({
    name: z.string().min(1).max(200).optional(),
    sector: z.string().max(100).nullable().optional(),
    addDomains: z.array(z.string().max(253)).optional(),
    removeDomains: z.array(z.string().max(253)).optional(),
    addTags: z.array(z.string().min(1).max(50)).optional(),
    removeTags: z.array(z.string().min(1).max(50)).optional(),
    ownerEmail: z.string().email().nullable().optional(),
    source: z.string().max(80).nullable().optional(),
    lifecycleStage: CrmLifecycleStageSchema.optional(),
});
export const CompanyMergeSchema = z
    .object({
    sourceId: z.string().uuid(),
    targetId: z.string().uuid(),
})
    .refine((data) => data.sourceId !== data.targetId, {
    message: "Source and target companies must be different",
});
// ─── Duplicate Candidates ─────────────────────────────────
export const CompanyDuplicateQuerySchema = z.object({
    limit: z.coerce.number().int().min(1).max(50).default(20),
});
export const CompanyDuplicateReasonSchema = z.enum(["same_normalized_name", "shared_domain"]);
export const CompanyDuplicateCandidateSchema = z.object({
    id: z.string().min(1),
    reason: CompanyDuplicateReasonSchema,
    confidence: z.number().min(0).max(1),
    summary: z.string().min(1),
    companies: z.array(CompanySchema).min(2),
});
export const CompanyDuplicateListResponseSchema = z.object({
    candidates: z.array(CompanyDuplicateCandidateSchema),
    total: z.number().int(),
});
// ─── Query ─────────────────────────────────────────────────
export const CompanyListQuerySchema = z.object({
    search: z.string().max(200).optional(),
    sector: z.string().max(100).optional(),
    // Admin-only opt-ins. Server enforces; non-admins always see active-only.
    includeArchived: z.coerce.boolean().optional(),
    archivedOnly: z.coerce.boolean().optional(),
    limit: z.coerce.number().int().min(1).max(100).default(50),
    offset: z.coerce.number().int().min(0).default(0),
});
// ─── Response ──────────────────────────────────────────────
export const CompanyListResponseSchema = z.object({
    companies: z.array(CompanySchema),
    total: z.number().int(),
});
//# sourceMappingURL=companies.js.map